import { TextField } from '@mui/material';
import React, { useState } from 'react';

import { GridRenderEditCellParams } from '@mui/x-data-grid';
import { validInteger } from 'app/helpers/numberHelper';
import { IPets } from 'app/models/Placement/PlacementMods';
import { Controller, useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { selectEditPreferencePetsRows } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { findIndex, findRow } from '../AdultGridComponents/AdultNameCell';
import { getDisplayValue } from '../utils';

interface GridCellProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export const PetWeightCell = (cellParams: GridRenderEditCellParams) => {
  return (
    <>
      <PetWeight cellParams={cellParams} />
    </>
  );
};

const PetWeight = React.memo(function PetWeight(cellParams: GridCellProps) {
  const { control } = useFormContext();
  const dispatch = useDispatch();
  const editPreferencePetsRequests = useSelector(selectEditPreferencePetsRows);
  const RowId = cellParams?.cellParams?.id;
  const rowData = getDisplayValue(RowId, editPreferencePetsRequests);
  const weight = rowData?.weight;
  const [petWeight, setPetWeight] = useState(weight === '--' ? null : weight);

  const setWeightForPetGridEdit = data => {
    let newRows = editPreferencePetsRequests.slice(0);
    let petsGridEditRow = findRow(editPreferencePetsRequests, RowId);

    let updatedWeight = {} as IPets;

    updatedWeight = {
      ...petsGridEditRow,
      weight: data ? parseInt(data) : '',
    };

    let editWeightIndex = findIndex(editPreferencePetsRequests, RowId);
    newRows[editWeightIndex] = updatedWeight;
    dispatch(placementModsAction.setEditPetsRows(newRows));
  };

  return (
    <>
      <Controller
        name={`petsGrid${RowId}.weight`}
        control={control}
        render={({ field: { onChange, onBlur, ...rest } }) => (
          <TextField
            required={true}
            variant="outlined"
            size={'small'}
            sx={{
              width: '150px',
            }}
            value={petWeight}
            onBlur={e => {
              if (validInteger(e.target.value, { numberLength: 4 })) {
                setWeightForPetGridEdit(e.target.value);
              }
              onChange(e.target.value);
              onBlur();
            }}
            onChange={e => {
              if (e.target.value) {
                if (validInteger(e.target.value, { numberLength: 4 })) {
                  setPetWeight(!Number.isNaN(e.target.value) ? e.target.value : '');
                  onChange(!Number.isNaN(e.target.value) ? e.target.value : '');
                } else {
                  setPetWeight('');
                }
              } else {
                setPetWeight('');
              }
            }}
            {...rest}
          />
        )}
      />
    </>
  );
});
